import axios from 'axios'
import { EmailData } from '../interfaces/EmailData'
const url = process.env.REACT_APP_API_URL
export async function postEmail(data: EmailData): Promise<void> {
	await axios.post(`${url}/`, data)
}
